import React, { Component } from 'react'
import { connect } from 'react-redux'
import LocationForm from './LocationForm'
import { updateInMemoryLocation, saveLocation } from './locations-reducer'

class LocationFormContainer extends Component {
  render () {
    const {
      inMemoryLocation,
      updateInMemoryLocation,
      saveLocation,
      requestOngoing,
      successMsg,
      clients
    } = this.props

    /**
     * This is used to handle any changes from our create location form
     */
    const handleFormChange = (field, value) => {
      updateInMemoryLocation({ [field]: value })
    }

    return (
      <div>
        <h4>
          {inMemoryLocation._id ? 'Edit Location' : 'Create Location Form'}
        </h4>
        <LocationForm
          name={inMemoryLocation.name}
          contactName={inMemoryLocation.contactName}
          contactPhone={inMemoryLocation.contactPhone}
          city={inMemoryLocation.city}
          country={inMemoryLocation.country}
          pickup={inMemoryLocation.pickup}
          street={inMemoryLocation.street}
          latitude={inMemoryLocation.latitude}
          longitude={inMemoryLocation.longitude}
          onFormChange={handleFormChange}
          onLocationSave={() => saveLocation()}
          requestOngoing={requestOngoing}
          successMsg={successMsg}
          clientId={inMemoryLocation.clientId}
          clients={clients}
        />
      </div>
    )
  }
}

const mapStateToProps = ({ locations, users: {clients} }) => ({
  inMemoryLocation: locations.inMemoryLocation,
  error: locations.error,
  requestOngoing: locations.requestOngoing,
  successMsg: locations.successMsg,
  clients
})

const mapDispatchToProps = {
  updateInMemoryLocation,
  saveLocation
}

export default connect(mapStateToProps, mapDispatchToProps)(
  LocationFormContainer
)



// WEBPACK FOOTER //
// ./src/locations/LocationFormContainer.js